import styles from './styles.module.css';

const BooleanImage = ({ value }: { value: boolean | undefined }) => {
    const src = value ? '/icons/check-wt.svg' : '/icons/cross.svg';

    return <img alt={''} src={src} className={styles.img} />;
};

export default BooleanImage;
